module.exports = __webpack_public_path__ + "static/img/process.86ea728f.png";